import React from 'react';
import { useAPIContext } from '../../../../frontend-brands/src/context/api';
import { BrandsAPI } from '../../../../constructs/brands/interface';

export const useSendToSocial = () => {
  const { callEndpoint } = useAPIContext();

  const setVisibleInSocial = React.useCallback(
    async (bannerId: string, visible: boolean) => {
      try {
        if (!bannerId) throw new Error('bannerId es requerido');

        const res = await callEndpoint<BrandsAPI, 'set-visible-in-social'>(
          'brands',
          `/banners/${bannerId}/visible-in-social`,
          'POST',
          { visible }
        );

        if (!res) throw new Error('Respuesta del servidor inesperada');

        return res; // updated creativity
      } catch (error: any) {
        console.error('Error al enviar a Social:', error);
        return null;
      }
    },
    [callEndpoint]
  );

  return { setVisibleInSocial };
};
